// uncomment for packing
// import "../styles/index.scss";
function $40eacaf1f00b189f$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $40eacaf1f00b189f$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $40eacaf1f00b189f$var$passiveTestOptions = {
        get passive () {
            $40eacaf1f00b189f$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $40eacaf1f00b189f$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $40eacaf1f00b189f$var$passiveTestOptions);
}
var $40eacaf1f00b189f$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $40eacaf1f00b189f$var$locks = [];
var $40eacaf1f00b189f$var$documentListenerAdded = false;
var $40eacaf1f00b189f$var$initialClientY = -1;
var $40eacaf1f00b189f$var$previousBodyOverflowSetting = void 0;
var $40eacaf1f00b189f$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $40eacaf1f00b189f$var$allowTouchMove = function allowTouchMove(el) {
    return $40eacaf1f00b189f$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $40eacaf1f00b189f$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($40eacaf1f00b189f$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $40eacaf1f00b189f$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($40eacaf1f00b189f$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $40eacaf1f00b189f$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($40eacaf1f00b189f$var$previousBodyOverflowSetting === undefined) {
        $40eacaf1f00b189f$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $40eacaf1f00b189f$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($40eacaf1f00b189f$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $40eacaf1f00b189f$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $40eacaf1f00b189f$var$previousBodyPaddingRight = undefined;
    }
    if ($40eacaf1f00b189f$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $40eacaf1f00b189f$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $40eacaf1f00b189f$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $40eacaf1f00b189f$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $40eacaf1f00b189f$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $40eacaf1f00b189f$var$initialClientY;
    if ($40eacaf1f00b189f$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $40eacaf1f00b189f$var$preventDefault(event);
    if ($40eacaf1f00b189f$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $40eacaf1f00b189f$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $40eacaf1f00b189f$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($40eacaf1f00b189f$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $40eacaf1f00b189f$var$locks = [].concat($40eacaf1f00b189f$var$_toConsumableArray($40eacaf1f00b189f$var$locks), [
        lock
    ]);
    if ($40eacaf1f00b189f$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $40eacaf1f00b189f$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $40eacaf1f00b189f$var$handleScroll(event, targetElement);
        };
        if (!$40eacaf1f00b189f$var$documentListenerAdded) {
            document.addEventListener("touchmove", $40eacaf1f00b189f$var$preventDefault, $40eacaf1f00b189f$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $40eacaf1f00b189f$var$documentListenerAdded = true;
        }
    } else $40eacaf1f00b189f$var$setOverflowHidden(options);
};
var $40eacaf1f00b189f$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($40eacaf1f00b189f$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $40eacaf1f00b189f$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($40eacaf1f00b189f$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $40eacaf1f00b189f$var$preventDefault, $40eacaf1f00b189f$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $40eacaf1f00b189f$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $40eacaf1f00b189f$var$initialClientY = -1;
    } else $40eacaf1f00b189f$var$restoreOverflowSetting();
    $40eacaf1f00b189f$var$locks = [];
};
var $40eacaf1f00b189f$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $40eacaf1f00b189f$var$locks = $40eacaf1f00b189f$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($40eacaf1f00b189f$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($40eacaf1f00b189f$var$documentListenerAdded && $40eacaf1f00b189f$var$locks.length === 0) {
            document.removeEventListener("touchmove", $40eacaf1f00b189f$var$preventDefault, $40eacaf1f00b189f$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $40eacaf1f00b189f$var$documentListenerAdded = false;
        }
    } else if (!$40eacaf1f00b189f$var$locks.length) $40eacaf1f00b189f$var$restoreOverflowSetting();
};


class $a2559084a20456c9$var$ImageCompare {
    constructor(el, settings = {}){
        const defaults = {
            controlColor: "#FFFFFF",
            controlShadow: true,
            addCircle: false,
            addCircleBlur: true,
            showLabels: false,
            labelOptions: {
                before: "Before",
                after: "After",
                onHover: false
            },
            smoothing: true,
            smoothingAmount: 100,
            hoverStart: false,
            verticalMode: false,
            startingPoint: 50,
            fluidMode: false
        };
        this.settings = Object.assign(defaults, settings);
        this.safariAgent = navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1;
        this.el = el;
        this.images = {};
        this.wrapper = null;
        this.control = null;
        this.arrowContainer = null;
        this.arrowAnimator = [];
        this.active = false;
        this.slideWidth = 50;
        this.lineWidth = 2;
        this.arrowCoordinates = {
            circle: [
                5,
                3
            ],
            standard: [
                8,
                0
            ]
        };
    }
    mount() {
        // Temporarily disable Safari smoothing
        if (this.safariAgent) this.settings.smoothing = false;
        this._shapeContainer();
        this._getImages();
        this._buildControl();
        this._events();
    }
    _events() {
        let bodyStyles = `

    `;
        // Desktop events
        this.el.addEventListener("mousedown", (ev)=>{
            this._activate(true);
            document.body.classList.add("icv__body");
            (0, $40eacaf1f00b189f$export$24fdf68abf432c44)(this.el, {
                reserveScrollBarGap: true
            });
            this._slideCompare(ev);
        });
        this.el.addEventListener("mousemove", (ev)=>this.active && this._slideCompare(ev));
        this.el.addEventListener("mouseup", ()=>this._activate(false));
        document.body.addEventListener("mouseup", ()=>{
            document.body.classList.remove("icv__body");
            (0, $40eacaf1f00b189f$export$e5d0524c3725571e)(this.el);
            this._activate(false);
        });
        // Mobile events
        this.control.addEventListener("touchstart", (e)=>{
            this._activate(true);
            document.body.classList.add("icv__body");
            (0, $40eacaf1f00b189f$export$24fdf68abf432c44)(this.el, {
                reserveScrollBarGap: true
            });
        });
        this.el.addEventListener("touchmove", (ev)=>{
            this.active && this._slideCompare(ev);
        });
        this.el.addEventListener("touchend", ()=>{
            this._activate(false);
            document.body.classList.remove("icv__body");
            (0, $40eacaf1f00b189f$export$e5d0524c3725571e)(this.el);
        });
        // hover
        this.el.addEventListener("mouseenter", ()=>{
            this.settings.hoverStart && this._activate(true);
            let coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
            this.arrowAnimator.forEach((anim, i)=>{
                anim.style.cssText = `
        ${this.settings.verticalMode ? `transform: translateY(${coord[1] * (i === 0 ? 1 : -1)}px);` : `transform: translateX(${coord[1] * (i === 0 ? 1 : -1)}px);`}
        `;
            });
        });
        this.el.addEventListener("mouseleave", ()=>{
            let coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
            this.arrowAnimator.forEach((anim, i)=>{
                anim.style.cssText = `
        ${this.settings.verticalMode ? `transform: translateY(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});` : `transform: translateX(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});`}
        `;
            });
        });
    }
    _slideCompare(ev) {
        let bounds = this.el.getBoundingClientRect();
        let x = ev.touches !== undefined ? ev.touches[0].clientX - bounds.left : ev.clientX - bounds.left;
        let y = ev.touches !== undefined ? ev.touches[0].clientY - bounds.top : ev.clientY - bounds.top;
        let position = this.settings.verticalMode ? y / bounds.height * 100 : x / bounds.width * 100;
        if (position >= 0 && position <= 100) {
            this.settings.verticalMode ? this.control.style.top = `calc(${position}% - ${this.slideWidth / 2}px)` : this.control.style.left = `calc(${position}% - ${this.slideWidth / 2}px)`;
            if (this.settings.fluidMode) this.settings.verticalMode ? this.wrapper.style.clipPath = `inset(0 0 ${100 - position}% 0)` : this.wrapper.style.clipPath = `inset(0 0 0 ${position}%)`;
            else this.settings.verticalMode ? this.wrapper.style.height = `calc(${position}%)` : this.wrapper.style.width = `calc(${100 - position}%)`;
        }
    }
    _activate(state) {
        this.active = state;
    }
    _shapeContainer() {
        let imposter = document.createElement("div");
        let label_l = document.createElement("span");
        let label_r = document.createElement("span");
        label_l.classList.add("icv__label", "icv__label-before", "keep");
        label_r.classList.add("icv__label", "icv__label-after", "keep");
        if (this.settings.labelOptions.onHover) {
            label_l.classList.add("on-hover");
            label_r.classList.add("on-hover");
        }
        if (this.settings.verticalMode) {
            label_l.classList.add("vertical");
            label_r.classList.add("vertical");
        }
        label_l.innerHTML = this.settings.labelOptions.before || "Before";
        label_r.innerHTML = this.settings.labelOptions.after || "After";
        if (this.settings.showLabels) {
            this.el.appendChild(label_l);
            this.el.appendChild(label_r);
        }
        this.el.classList.add(`icv`, this.settings.verticalMode ? `icv__icv--vertical` : `icv__icv--horizontal`, this.settings.fluidMode ? `icv__is--fluid` : `standard`);
        imposter.classList.add("icv__imposter");
        this.el.appendChild(imposter);
    }
    _buildControl() {
        let control = document.createElement("div");
        let uiLine = document.createElement("div");
        let arrows = document.createElement("div");
        let circle = document.createElement("div");
        const arrowSize = "20";
        arrows.classList.add("icv__theme-wrapper");
        for(var idx = 0; idx <= 1; idx++){
            let animator = document.createElement(`div`);
            let arrow = `<svg
      height="15"
      width="15"
       style="
       transform: 
       scale(${this.settings.addCircle ? 0.7 : 1.5})  
       rotateZ(${idx === 0 ? this.settings.verticalMode ? `-90deg` : `180deg` : this.settings.verticalMode ? `90deg` : `0deg`}); height: ${arrowSize}px; width: ${arrowSize}px;
       
       ${this.settings.controlShadow ? `
       -webkit-filter: drop-shadow( 0px 3px 5px rgba(0, 0, 0, .33));
       filter: drop-shadow( 0px ${idx === 0 ? "-3px" : "3px"} 5px rgba(0, 0, 0, .33));
       ` : ``}
       "
       xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 15 15">
       <path ${this.settings.addCircle ? `fill="transparent"` : `fill="${this.settings.controlColor}"`}
       stroke="${this.settings.controlColor}"
       stroke-linecap="round"
       stroke-width="${this.settings.addCircle ? 3 : 0}"
       d="M4.5 1.9L10 7.65l-5.5 5.4"
       />
     </svg>`;
            animator.innerHTML += arrow;
            this.arrowAnimator.push(animator);
            arrows.appendChild(animator);
        }
        let coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
        this.arrowAnimator.forEach((anim, i)=>{
            anim.classList.add("icv__arrow-wrapper");
            anim.style.cssText = `
      ${this.settings.verticalMode ? `transform: translateY(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});` : `transform: translateX(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});`}
      `;
        });
        control.classList.add("icv__control");
        control.style.cssText = `
    ${this.settings.verticalMode ? `height` : `width `}: ${this.slideWidth}px;
    ${this.settings.verticalMode ? `top` : `left `}: calc(${this.settings.startingPoint}% - ${this.slideWidth / 2}px);
    ${"ontouchstart" in document.documentElement ? `` : this.settings.smoothing ? `transition: ${this.settings.smoothingAmount}ms ease-out;` : ``}
    `;
        uiLine.classList.add("icv__control-line");
        uiLine.style.cssText = `
      ${this.settings.verticalMode ? `height` : `width `}: ${this.lineWidth}px;
      background: ${this.settings.controlColor};
        ${this.settings.controlShadow ? `box-shadow: 0px 0px 15px rgba(0,0,0,0.33);` : ``}
    `;
        let uiLine2 = uiLine.cloneNode(true);
        circle.classList.add("icv__circle");
        circle.style.cssText = `

      ${this.settings.addCircleBlur && `-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px)`};
      
      border: ${this.lineWidth}px solid ${this.settings.controlColor};
      ${this.settings.controlShadow && `box-shadow: 0px 0px 15px rgba(0,0,0,0.33)`};
    `;
        control.appendChild(uiLine);
        this.settings.addCircle && control.appendChild(circle);
        control.appendChild(arrows);
        control.appendChild(uiLine2);
        this.arrowContainer = arrows;
        this.control = control;
        this.el.appendChild(control);
    }
    _getImages() {
        let children = this.el.querySelectorAll("img, .keep");
        this.el.innerHTML = "";
        children.forEach((img)=>{
            this.el.appendChild(img);
        });
        let childrenImages = [
            ...children
        ].filter((element)=>element.nodeName.toLowerCase() === "img");
        //  this.settings.verticalMode && [...children].reverse();
        this.settings.verticalMode && childrenImages.reverse();
        for(let idx = 0; idx <= 1; idx++){
            let child = childrenImages[idx];
            child.classList.add("icv__img");
            child.classList.add(idx === 0 ? `icv__img-a` : `icv__img-b`);
            if (idx === 1) {
                let wrapper = document.createElement("div");
                let afterUrl = childrenImages[1].src;
                wrapper.classList.add("icv__wrapper");
                wrapper.style.cssText = `
            width: ${100 - this.settings.startingPoint}%; 
            height: ${this.settings.startingPoint}%;

            ${"ontouchstart" in document.documentElement ? `` : this.settings.smoothing ? `transition: ${this.settings.smoothingAmount}ms ease-out;` : ``}
            ${this.settings.fluidMode && `background-image: url(${afterUrl}); clip-path: inset(${this.settings.verticalMode ? ` 0 0 ${100 - this.settings.startingPoint}% 0` : `0 0 0 ${this.settings.startingPoint}%`})`}
        `;
                wrapper.appendChild(child);
                this.wrapper = wrapper;
                this.el.appendChild(this.wrapper);
            }
        }
        if (this.settings.fluidMode) {
            let url = childrenImages[0].src;
            let fluidWrapper = document.createElement("div");
            fluidWrapper.classList.add("icv__fluidwrapper");
            fluidWrapper.style.cssText = `
 
        background-image: url(${url});
        
      `;
            this.el.appendChild(fluidWrapper);
        }
    }
}
var // const el = document.querySelectorAll(".image-compare");
// el.forEach((viewer) => {
//   let v = new ImageCompare(viewer, {
//     controlShadow: false,
//     showLabels: true,
//     labelOptions: {
//       onHover: true,
//       before: "Draft",
//       after: "Final",
//     },
//   }).mount();
// });
$a2559084a20456c9$export$2e2bcd8739ae039 = $a2559084a20456c9$var$ImageCompare;


function $835942442b1590bf$var$handleImageSelectionEvent(e) {
    $835942442b1590bf$var$selectImageForComparison(e.target);
}
function $835942442b1590bf$var$selectImageForComparison(target) {
    let imageComparison = document.getElementById("comparison-container");
    while(imageComparison.hasChildNodes())imageComparison.removeChild(imageComparison.lastChild);
    let imageAfter = target.cloneNode();
    imageAfter.className = "aspect-[3/4]";
    imageComparison.appendChild(imageAfter);
    let imageBefore = target.previousElementSibling;
    if (imageBefore) {
        imageBefore = target.previousElementSibling.cloneNode();
        imageBefore.className = "aspect-[3/4]";
        imageComparison.appendChild(imageBefore);
    }
    if (imageBefore) new (0, $a2559084a20456c9$export$2e2bcd8739ae039)(imageComparison, {
        "controlColor": "#cbe6e1",
        "controlShadow": true,
        "addCircle": true,
        "addCircleBlur": true,
        "smoothing": true,
        "smoothingAmount": 100,
        "startingPoint": 10
    }).mount();
}
function $835942442b1590bf$var$updateImageListOpacity() {
    let containerRect = $835942442b1590bf$var$comparison_images_container.getBoundingClientRect();
    $835942442b1590bf$var$comparison_images.forEach((image)=>{
        let imageRect = image.getBoundingClientRect();
        let fullyViewable = imageRect.left >= containerRect.left - 3 && imageRect.right <= containerRect.right + 3;
        if (fullyViewable) image.classList.remove("opacity-50");
        else image.classList.add("opacity-50");
    });
}
const $835942442b1590bf$var$comparison_images = document.querySelectorAll(".comparison-image");
const $835942442b1590bf$var$comparison_images_container = document.getElementById("our-work-images");
$835942442b1590bf$var$comparison_images.forEach((image)=>{
    image.addEventListener("click", $835942442b1590bf$var$handleImageSelectionEvent);
    image.addEventListener("load", $835942442b1590bf$var$updateImageListOpacity);
});
$835942442b1590bf$var$comparison_images_container.addEventListener("scroll", $835942442b1590bf$var$updateImageListOpacity);
$835942442b1590bf$var$selectImageForComparison($835942442b1590bf$var$comparison_images[0]);


//# sourceMappingURL=index.f88cca6b.js.map
